import { render } from "./Button-solicitar-contato.vue?vue&type=template&id=46d1ff76&scoped=true"
import script from "./Button-solicitar-contato.vue?vue&type=script&lang=js"
export * from "./Button-solicitar-contato.vue?vue&type=script&lang=js"

import "./Button-solicitar-contato.vue?vue&type=style&index=0&id=46d1ff76&scoped=true&lang=css"

import exportComponent from "E:\\amapa-lp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d1ff76"]])

export default __exports__